import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';
import { type AuthResponseData, saveAuth } from './saveAuth';

export const tokenCheck: GlobalStateCommandFactory<boolean | undefined> =
  (cmdContext, dispatch) => async () => {
    const responseData = await cmdContext.api.request<AuthResponseData>({
      url: '/auth/token/check',
      method: 'GET',
    });
    dispatch(saveAuth, responseData);
  };
